import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-predective-search',
  templateUrl: './predective-search-updated.component.html',
  styleUrls: ['./predective-search.component.scss'],
})
export class PredectiveSearchComponent implements OnInit {
  showSearchBox = false;
  showIntegerCriteria: boolean = false;
  showStringCriteria: boolean = false;
  showDateCriteria: boolean = false;
  @Input() isKeyStrokeSearch = true;
  @Input() isNewPreview = false;
  @Input() isCompact = false;
  @Input() isWrapper = true;
  @Input() fields: Array<Fields> | undefined;
  @Input() placeholder: string = 'Search';
  @Input() callbackFunction: ((field: string, fieldValue: string, criteria: string) => void) | undefined;
  @Input() callbackClearFunction: (() => void) | undefined;

  @ViewChild('searchInput') searchInput!: ElementRef;

  criteria: string = '';
  field: string = '';
  fieldValue: string = '';
  fieldActiveIndex: number = 0;
  criteriaActiveIndex: number = 0;
  showModule: boolean = false;
  showFilter = false;

  searchStringCriteria: Array<FieldsCriteria> = [
    { Name: 'Equals', Value: 'EQ' },
    { Name: 'Contains', Value: 'CT' },
    { Name: 'StartsWith', Value: 'SW' },
    { Name: 'EndsWith', Value: 'EW' },
  ];

  searchIntegerCriteria: Array<FieldsCriteria> = [
    { Name: 'Equals', Value: 'EQ' },
    { Name: 'Greater Than', Value: 'GT' },
    { Name: 'Greater Than Equals', Value: 'GTE' },
    { Name: 'Less Than', Value: 'LT' },
    { Name: 'Less Than Equals', Value: 'LTE' },
  ];
  private searchSubject = new Subject<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.fields != undefined) {
      if (this.fields[0].Type == 'string') {
        this.showIntegerCriteria = false;
        this.showDateCriteria = false;
        this.showStringCriteria = true;

        this.criteria = this.searchStringCriteria[0].Value;
      } else if (this.fields[0].Type == 'int') {
        this.showIntegerCriteria = true;
        this.showStringCriteria = false;
        this.showDateCriteria = false;

        this.criteria = this.searchIntegerCriteria[0].Value;
      } else if (this.fields[0].Type == 'date') {
        this.showIntegerCriteria = false;
        this.showStringCriteria = false;
        this.showDateCriteria = true;

        this.criteria = this.searchIntegerCriteria[0].Value;
      }
      this.field = this.fields[0].Value;
    }
    this.searchSubject
      .pipe(debounceTime(300)) // adjust delay (ms)
      .subscribe((event) => {
        if (this.isKeyStrokeSearch) {
          this.search();
        }
      });
  }

  onInput(e: any, type: string) {
    if (type === 'focus') {
      this.showSearchBox = true;
    }
    // if (this.fields != undefined) this.field = this.fields[0].Value;

    // this.criteria = this.searchCriteria[0].Value;
  }

  handleShowFilter() {
    this.showFilter = !this.showFilter;
  }

  onClickOutSide(e: any) {
    this.showSearchBox = false;
  }

  setCriteria(criteria: string, index: number) {
    this.criteriaActiveIndex = index;
    this.criteria = criteria;
  }

  setField(field: string, index: number, type: string) {
    //(this.fieldElem.nativeElement as HTMLParagraphElement).parentElement?.classList.add("active");
    this.fieldActiveIndex = index;
    this.field = field;

    if (type == 'string') {
      this.showIntegerCriteria = false;
      this.showDateCriteria = false;
      this.showStringCriteria = true;
    } else if (type == 'int') {
      this.showIntegerCriteria = true;
      this.showStringCriteria = false;
      this.showDateCriteria = false;
    } else if (type == 'date') {
      this.showIntegerCriteria = false;
      this.showStringCriteria = false;
      this.showDateCriteria = true;

      this.criteria = this.searchIntegerCriteria[0].Value;
    }
  }
  // onChangeValue(event: any) {
  //   if (event.keyCode == 13) {
  //     this.search();
  //   }
  //   this.fieldValue = event.target.value;
  //   //* Clear Data on search field empty
  //   if (this.fieldValue.trim() === '') {
  //     if (this.callbackClearFunction !== undefined) {
  //       this.callbackClearFunction();
  //       return;
  //     }
  //   } else {
  //     this.isKeyStrokeSearch && this.search();
  //   }
  // }

  onChangeValue(event: any) {
    this.fieldValue = event.target.value;

    // Clear when empty (no delay needed)
    if (this.fieldValue.trim() === '') {
      if (this.callbackClearFunction) {
        this.callbackClearFunction();
      }
      return;
    }

    // Push event into debounce stream
    this.searchSubject.next(event);

    // Enter key should still search immediately
    if (event.keyCode === 13) {
      this.search();
    }
  }

  search() {
    if (this.callbackFunction !== undefined && this.fieldValue.trim() !== '') {
      this.callbackFunction(this.field, this.fieldValue, this.criteria);
      return;
    }
    // else if (this.callbackClearFunction !== undefined && this.fieldValue.trim() === '') {
    //   this.callbackClearFunction();
    //   return;
    // }
  }

  clearSearch() {
    this.searchInput.nativeElement.value = this.fieldValue = '';
    if (this.callbackClearFunction !== undefined) {
      this.callbackClearFunction();
      return;
    }
  }
  clearSearchFieldOnly() {
    this.searchInput.nativeElement.value = this.fieldValue = '';
  }
}

export interface Fields {
  Name: string;
  Value: string;
  Type: string;
}

export interface FieldsCriteria {
  Name: string;
  Value: string;
}
